
const BlobRequest = () => {
  const getFilename = (resp, filename) => {
    if (filename !== undefined && filename !== '' && filename !== null) {
      return filename;
    }
    const contentDisposition = resp._response.headers['content-disposition'];
    if (contentDisposition) {
      const regex = /filename=(.*);/gm;
      const match = regex.exec(contentDisposition);
      return match[1] || 'download';
    }
    return 'download';
  };

  return {
    forceDownload(response, fileName) {
      if (response.ok === undefined || response.ok === false) {
        throw Error('Response não é válido');
      }

      const url = window.URL.createObjectURL(response);
      const link = document.createElement('a');

      link.href = url;
      link.setAttribute('download', getFilename(response, fileName));
      document.body.appendChild(link);
      link.click();
      link.remove();
    }
  };
};
export default BlobRequest();
